export default __webpack_public_path__ + "assets/ico_booking_calendar-0efa676c.svg";